import React, {FC, useEffect} from 'react'
import {useFormContext} from 'react-hook-form'
import {InputTextWrapper} from '../../../../../../components/UI/Form/Input'
import {CategoryModel} from '../../../../model'
import {getCategoryById} from '../../../../services'
import {useCentral} from '../../../../../../hooks/useCentral'
import ContentForm from '../../../../../../components/UI/Form/contentForm'
import {TITLE_FORM_CATEGORY} from '../../../../util/Constants'
const initValues: CategoryModel = {
  id: '',
  codigo: '',
  nombre: '',
}

const Option: FC = () => {
  const {setValue} = useFormContext()
  const {currentTabItem} = useCentral()

  const getCategoryByIdValues = async () => {
    const response = await getCategoryById(currentTabItem.idToEdit)
    const data = response.data.data
    type CategoryModelKeys = keyof CategoryModel

    for (const fieldName in initValues) {
      if (initValues.hasOwnProperty(fieldName)) {
        if (data.hasOwnProperty(fieldName)) {
          if (data[fieldName as CategoryModelKeys]) {
            setValue(fieldName, data[fieldName as CategoryModelKeys])
          } else {
            setValue(fieldName, '')
          }
        }
      }
    }
  }
  useEffect(() => {
    if (currentTabItem.idToEdit) {
      getCategoryByIdValues()
    }
  }, [currentTabItem.idToEdit])
  let isDisabled = currentTabItem.idToEdit ? true : false

  return (
    <ContentForm isEdit={isDisabled} title={TITLE_FORM_CATEGORY}>
      <div className='row'>
        <div className='col-sm-12 col-lg-3'>
          <InputTextWrapper
            labelText='Código'
            name='codigo'
            textPlaceholder='Escribe el código'
            disabled={isDisabled}
            required
          />
        </div>
        <div className='col-sm-12 col-lg-3'>
          <InputTextWrapper
            labelText='Nombre'
            name='nombre'
            textPlaceholder='Escribe el nombre'
            required
          />
        </div>
      </div>
    </ContentForm>
  )
}

export default Option
